import React from 'react';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { labels } from '../data/labels';
import { AgendaStreamingContext } from './AgendaStreamingContextProvider';

function AgendaStreamingSelection(props) {
    const agendaStreamingContext = React.useContext(AgendaStreamingContext)
    
	function handleClick() {
		props.onClick();
	}

    const selected = props.selected ? ' selected' : '';
    const icoAgendaStr = 'icoAgendaStr';

    return (
        <div  className={`nav-slider-item-container sport-img-slider icona-streaming ${selected}`} style={{order: props.order}} onClick={handleClick}>
             {props.counter != null &&
                <div className="sport-img-slider-count">{props.counter}</div>
             }
            <div className="sport-img-container">
                <div className={`sport-img ${icoAgendaStr}`}></div>
            </div>
            <div className="nav-slider-item">{labels['live_page.streams_schedule.live_feed']}</div>
        </div>
    );
}

export default AgendaStreamingSelection;